/*
    Every time our visitor filters the results,
    save the graphQL result in localStorage!

    Retrieve the saved result if they perform
    the same query later
*/
function retrieve(query) {

    return localStorage.getItem(query);

}

function save(query, data) {

    localStorage.setItem(query, data);

}

export const cache = {
    retrieve,
    save,
};
